// 1、自营优品 2、供应链 3、出厂价专区 4、首购专区 5、自营品牌专区
export const PRODUCT_SOURCE_FLAG = {
  OFFICIAL: 1, // 开心自营、自营优品
  CHAIN: 2, // 供应链
  FACTORY_PRICE: 3, // 出厂价专区
  FIRST_BUY: 4, // 首购专区
  OFFICIAL_BRAND: 5 // 自营品牌专区
}



// WEBPACK FOOTER //
// ./src/api/const.js